/* eslint-disable react/prop-types */
import React from 'react';

import classNames from 'classnames';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { Paper } from 'components';

const useStyles = makeStyles(styles);

const Portlet = (props) => {
  const { className, children, ...rest } = props;
  const classes = useStyles();

  const rootClassName = classNames(classes.root, className);

  return (
    <Paper
      {...rest}
      className={rootClassName}
      elevation={0}
      outlined
      square={false}
    >
      {children}
    </Paper>
  );
};

export default Portlet;
